import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { BuildingMeasuresOverviewExcelExportService } from '@cfp/shared/energy';
import { EnergyLabelSortPipe } from '@cfp/shared/energy-label';
import { Co2Module } from '@cfp/ui/pipes';
import { ExcelExportService } from '@cfp/ui/services';
import { PublicSharedBuildingLoginService } from 'csr-login-app';
import { BuildingReport } from './building-report';
import { ReportRoutingModule } from './report-routing';

@NgModule({
  imports: [BuildingReport],
  exports: [BuildingReport],
  providers: [
    PublicSharedBuildingLoginService,
    BuildingMeasuresOverviewExcelExportService,
    ExcelExportService,
    DatePipe,
    Co2Module,
    EnergyLabelSortPipe
  ]
})
export class ReportModule {}

@NgModule({
  imports: [ReportRoutingModule, ReportModule]
})
export class ReportModuleWithRouting {}
